import { Injectable } from '@angular/core';
import { isDefined } from 'angular';

import { BookingPhoneFacade, QualifRate } from '@contact/upgrade';

@Injectable({
  providedIn: 'root',
})
export class ChatActionsService {
  private callQualityRatesIndex: { [responseId: string]: QualifRate } = {};
  private selectedChatId: number | undefined;
  private isRatingCallQualityEnabled = false;

  constructor(private readonly bookingPhoneFacade: BookingPhoneFacade) {}

  setIsRatingCallQualityEnabled(isEnabled: boolean): void {
    this.isRatingCallQualityEnabled = isEnabled;
  }

  getIsRatingCallQualityEnabled(): boolean {
    return this.isRatingCallQualityEnabled;
  }

  selectChat(chatId: number): void {
    this.selectedChatId = chatId;
  }

  isChatSelected(): boolean {
    return !!this.selectedChatId;
  }

  deselectChat(): void {
    this.selectedChatId = undefined;
  }

  getCallQualityRate(responseId: string): QualifRate {
    if (isDefined(this.callQualityRatesIndex[responseId])) {
      return this.callQualityRatesIndex[responseId];
    } else {
      return 1;
    }
  }

  hangUp(responseId: string) {
    this.bookingPhoneFacade.hangUp(responseId);
  }
}
